//
// Chunk : App
//
// This is only an entry point for webpack chunk.
// There should be no other require than the
// "core" dependencies.
//

require("./core.js");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/chunk.app.js
 ** module id = 0
 ** module chunks = 1
 **/